import DEVICELIST from 'lan-scan/js/device-list';

angular.module("SupportAgent")
.controller(
 'localScanCtrl',
 ['$rootScope', '$scope',
 function ($rootScope, $scope) {
  DEVICELIST.hideBusyState = function(){
      $rootScope.showTestHistoryLoadingScreen=false;
  };
  DEVICELIST.showBusyState = function(){
      $rootScope.showTestHistoryLoadingScreen=true;
  };
  DEVICELIST.get_json = $rootScope.get_json;
  DEVICELIST.init($scope,{"p":"wifi"});
  DEVICELIST.controller($scope);
  DEVICELIST.lan_scan_list($scope);
}]);
